import React, { useEffect, useId, useState } from "react";

import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { useDispatch } from "react-redux";

import Cookie from "js-cookie";
import { AuthService } from "#services";
import { GlobalMessage, PageLoader } from "#components";
import MessageProvider from "../context/message";

const Login = React.lazy(() => import("#views/Login"));
const Auth = React.lazy(() => import("#views/Auth"));
const Error404 = React.lazy(() => import("#views/404"));
const Cadastro = React.lazy(() => import("#views/Cadastro"));
const Recover = React.lazy(() => import("#views/Recover"));
const Reset = React.lazy(() => import("#views/CreateNewPass"));
const FooterMenu = React.lazy(() => import("#components/global/footer"));

const routes = [
  { path: "/", exact: true, component: Login },
  { path: "/cadastro", exact: true, component: Cadastro },
  { path: "/recover", exact: true, component: Recover },
  { path: "/reset", exact: true, component: Reset },
  { path: "/auth/:aTkn?", exact: true, component: Auth },
  { path: "/404", exact: true, component: Error404 },
];

function Router(props) {
  const dispatch = useDispatch();
  const [ready, setReady] = useState(true);
  const id = useId();

  useEffect(() => {
    const token = Cookie.get("aTkn");
    if (token) {
      authenticate();
    } else {
      setReady(true);
    }
  }, []);

  const authenticate = async () => {
    try {
      AuthService.authenticate()
        .then((res) => {
          // Call auth service and validate token
          dispatch({
            type: "setUser",
            payload: {
              data: res.content,
              permissions: res.content.Administrator,
            },
          });
          window.location.assign(`${process.env.REACT_APP_MNWEB_DOMAIN}`);
        })
        .catch((err) => {
          //console.error(err.json());
          setReady(true);
        });
    } catch (e) {
      console.error(e);
      setReady(true);
    }
  };

  return (
    <div className="router">
      {ready && (
        <HashRouter>
          <React.Suspense
            fallback={
              <>
                <PageLoader suspense active={true} />
              </>
            }
          >
            <MessageProvider>
              <GlobalMessage />
              <Routes>
                {routes.map((route) => (
                  <Route
                    key={id}
                    path={route.path}
                    element={<route.component />}
                  />
                ))}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </MessageProvider>
            <FooterMenu />
          </React.Suspense>
        </HashRouter>
      )}
    </div>
  );
}

export default Router;
